<template>
  <transition-group
    leave-active-class="fade"
    enter-active-class="slideLeft"
    mode="out-in"
    duration="250"
  >
    <template v-if="!is_closed || should_force_open">
      <SidebarLarge
        :toggled="toggled"
        :fullscreen="should_fullscreen_show"
        @goFullscreen="go_fullscreen"
        @confirm="confirm"
        @toggleToggled="toggled = !toggled"
        key="sidebarLarge"
      />
    </template>
    <template v-else-if="is_closed || !should_force_open">
      <SidebarSmall
        :should_force_open="should_force_open"
        :name="configurator.name"
        @openSidebar="open_sidebar"
        key="sidebarSmall"
      />
    </template>
  </transition-group>
</template>

<script>
import { mapGetters } from 'vuex';
import { EventBus } from '../../eventBus';
import fscreen from 'fscreen';
import SidebarSmall from './SidebarSmall';
import SidebarLarge from './SidebarLarge';

export default {
  name: 'Sidebar',
  components: {
    SidebarSmall,
    SidebarLarge,
  },
  data: function() {
    return {
      is_closed: false,
      should_force_open: false,
      toggled: false,
      fullscreen: false,
      width: 76,
    };
  },
  computed: {
    ...mapGetters(['configurator']),
    should_fullscreen_show() {
      return fscreen.fullscreenEnabled;
    },
  },
  mounted: function() {
    EventBus.$on('close-sidebar', this.close_sidebar);
    EventBus.$on('open-sidebar', this.open_sidebar);
    this.check_sidebar_visibility();
    window.addEventListener('resize', this.check_sidebar_visibility);
    EventBus.$emit('open-sidebar');
  },
  methods: {
    check_sidebar_visibility() {
      this.should_force_open = window.innerWidth < 1200;
      this.is_closed = !(window.innerWidth < 1200);
    },
    close_sidebar() {
      this.is_closed = true;
    },
    open_sidebar() {
      this.is_closed = false;
    },
    go_fullscreen() {
      if (fscreen.fullscreenElement) fscreen.exitFullscreen();
      else fscreen.requestFullscreen(document.getElementById('app'));
    },
    confirm() {
      EventBus.$emit('confirm');
      EventBus.$emit('social');
    },
  },
};
</script>
